export default {
  title: 'Ich arbeite im Hintergrund'
}
